var PaymentResource = function() {
  var self = this;

  self.setupSubscription = function(transactionType, data, options) {
    request.post($.extend(true, {
      url: '/api/payment/gateway/' + transactionType + '/subscription',
      data: data
    }, options));
  };

  self.executeSubscription = function(transactionType, data, options) {
    request.post($.extend(true, {
      url: '/api/payment/gateway/' + transactionType + '/subscription/execute',
      data: data
    }, options));
  };

  self.setupBillingUpdate = function(transactionType, data, options) {
    request.post($.extend(true, {
      url: '/api/payment/gateway/' + transactionType + '/subscriptions',
      data: data
    }, options));
  };

  self.executeBillingUpdate = function(transactionType, data, options) {
    request.post($.extend(true, {
      url: '/api/payment/gateway/' + transactionType + '/subscriptions/execute',
      data: data
    }, options));
  };

  self.setupCreditsPayment = function(transactionType, data, options) {
    request.post($.extend(true, {
      url: '/api/payment/gateway/' + transactionType + '/credits',
      data: data
    }, options));
  };

  self.executeCreditsPayment = function(transactionType, data, options) {
    request.post($.extend(true, {
      url: '/api/payment/gateway/' + transactionType + '/credits/execute',
      data: data
    }, options));
  };

  self.config = {
    countries: {
      US: {
        placeholders: {
          address: 'Street address',
          address2: 'Apartment, suite, etc. (optional)',
          city: 'City',
          state: 'State',
          zip: 'ZIP code'
        },
        states: {
          "AL": "Alabama",
          "AK": "Alaska",
          "AS": "American Samoa",
          "AZ": "Arizona",
          "AR": "Arkansas",
          "CA": "California",
          "CO": "Colorado",
          "CT": "Connecticut",
          "DE": "Delaware",
          "DC": "District Of Columbia",
          "FM": "Federated States Of Micronesia",
          "FL": "Florida",
          "GA": "Georgia",
          "GU": "Guam",
          "HI": "Hawaii",
          "ID": "Idaho",
          "IL": "Illinois",
          "IN": "Indiana",
          "IA": "Iowa",
          "KS": "Kansas",
          "KY": "Kentucky",
          "LA": "Louisiana",
          "ME": "Maine",
          "MH": "Marshall Islands",
          "MD": "Maryland",
          "MA": "Massachusetts",
          "MI": "Michigan",
          "MN": "Minnesota",
          "MS": "Mississippi",
          "MO": "Missouri",
          "MT": "Montana",
          "NE": "Nebraska",
          "NV": "Nevada",
          "NH": "New Hampshire",
          "NJ": "New Jersey",
          "NM": "New Mexico",
          "NY": "New York",
          "NC": "North Carolina",
          "ND": "North Dakota",
          "MP": "Northern Mariana Islands",
          "OH": "Ohio",
          "OK": "Oklahoma",
          "OR": "Oregon",
          "PW": "Palau",
          "PA": "Pennsylvania",
          "PR": "Puerto Rico",
          "RI": "Rhode Island",
          "SC": "South Carolina",
          "SD": "South Dakota",
          "TN": "Tennessee",
          "TX": "Texas",
          "UT": "Utah",
          "VT": "Vermont",
          "VI": "Virgin Islands",
          "VA": "Virginia",
          "WA": "Washington",
          "WV": "West Virginia",
          "WI": "Wisconsin",
          "WY": "Wyoming"
        }
      },
    
      /********* AUSTRALIA ********/
      AU: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'Suburb',
          state: 'State/Territory',
          zip: 'Postcode'
        },
        excludes: {
          state: true // Excluding this for now; only doing US and Canada state codes
        },
        states: {
          "ACT": "Australian Capital Territory",
          "NSW": "New South Wales",
          "NT": "Northern Territory",
          "QLD": "Queensland",
          "SA": "South Australia",
          "TAS": "Tasmania",
          "VIC": "Victoria",
          "WA": "Western Australia"
        }
      },
    
      /********* United Kindom ********/
      GB: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2 (optional)',
          city: 'Town/City',
          zip: 'Postcode'
        },
        excludes: {
          state: true
        }
      },
    
      /********* Canada ********/
      CA: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          state: 'Province',
          zip: 'Postal code'
        },
        states: {
          "AB": "Alberta",
          "BC": "British Columbia",
          "MB": "Manitoba",
          "NB": "New Brunswick",
          "NL": "Newfoundland and Labrador",
          "NS": "Nova Scotia",
          "NT": "Northwest Territories",
          "NU": "Nunavut",
          "ON": "Ontario",
          "PE": "Prince Edward Island",
          "QC": "Quebec",
          "SK": "Saskatchewan",
          "YT": "Yukon"
        }
      },

      /********* Croatia *******/
      HR: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      },
    
      /********* United arab emirates ********/
      AE: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          state: 'Emirate'
        },
        excludes: {
          zip: true,
          state: true // Excluding this for now; only doing US and Canada state codes
        },
        states: {
          "AB": "Abu Dhabi",
          "AJ": "Ajman",
          "SH": "Sharjah",
          "DU": "Dubai",
          "FU": "Fujairah",
          "RA": "Ras Al Khaimah",
          "UM": "Umm Al Quwain"
        }
      },
    
      /************ Mexico ***********/
      MX: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Neighborhood / Quarter',
          city: 'City',
          state: 'State',
          zip: 'Postal code'
        },
        states: {
          "AG": "Aguascalientes",
          "BC": "Baja California",
          "BS": "Baja California Sur",
          "CM": "Campeche",
          "CS": "Chiapas",
          "CH": "Chihuahua",
          "MX": "Coahuila",
          "CL": "Colima",
          "DF": "Federal District",
          "DG": "Durango",
          "GT": "Guanajuato",
          "GR": "Guerrero",
          "HG": "Hidalgo",
          "JA": "Jalisco",
          "ME": "Mexico",
          "MI": "Michoacán",
          "MO": "Morelos",
          "NA": "Nayarit",
          "NL": "Nuevo León",
          "OA": "Oaxaca",
          "PU": "Puebla",
          "QE": "Querétaro",
          "QR": "Quintana Roo",
          "SL": "San Luis Potosí",
          "SI": "Sinaloa",
          "SO": "Sonora",
          "TB": "Tabasco",
          "TM": "Tamaulipas",
          "TL": "Tlaxcala",
          "VE": "Veracruz",
          "YU": "Yucatán",
          "ZA": "Zacatecas"
        }
      },
    
      /*********** Singapore **********/
      SG: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          zip: 'Postcode'
        },
        excludes: {
          state: true,
          city: true
        }
      },
    
      /********** France **********/
      FR: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          zip: 'Postal code',
          city: 'City'
        },
        excludes: {
          state: true
        }
      },
    
      /********** Sweden **********/
      SE: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          zip: 'Postal code',
          city: 'City / Town'
        },
        excludes: {
          state: true
        }
      },
    
      /********** Israel *********/
      IL: {
        placeholders: {
          address: 'Street and house number',
          address2: 'More address details',
          city: 'City',
          zip: 'ZIP code'
        },
        excludes: {
          state: true
        }
      },
    
      /******** Switzerland ********/
      CH: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      },
    
      /******** Spain *********/
      ES: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      },
    
      /********* Italy *******/
      IT: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      },
    
      /********* Denmark *******/
      DK: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      },
    
      /********* Norway *******/
      NO: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City / Town',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      },
    
      /********* Luxembourg *******/
      LU: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          zip: 'Post code'
        },
        excludes: {
          state: true
        }
      },
    
      /********* New Zealand *******/
      NZ: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City / Suburb',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      },
    
      /********* Japan *******/
      JP: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City / Town / Village',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      },
    
      /********* Russia *******/
      RU: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      },
    
      /********* BRAZIL *******/
      BR: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      },
    
      /********* Colombia *******/
      CO: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      },
    
      /********* Argentina *******/
      AR: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      },
    
      /********* Germany *******/
      DE: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      },
    
      /********* Indonesia *******/
      ID: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      },
    
      /********* India *******/
      IN: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      },
    
      /********* South Africa *******/
      ZA: {
        placeholders: {
          address: 'Address line 1',
          address2: 'Address line 2',
          city: 'City',
          zip: 'Postal code'
        },
        excludes: {
          state: true
        }
      }
    }
  };
}

window.paymentResource = new PaymentResource();